import React, { Component } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import ContentLayout from "../../../../partials/content/ContentLayout";
import Illustration from "../../../../partials/content/Illustration";
import {
  getQuotations,
  cancelQuotation,
} from "../../../../services/sales/quotationService";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import NumberFormat from "react-number-format";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import Swal from "sweetalert2";
import { Badge } from "react-bootstrap";
import { Card } from "primereact/card";
import withGlobalData from "../../common/withGlobalData";

class QuotationList extends Component {
  state = {
    reload: this.props.globalData.reload,
    auth: { create: false },
    quotations: [],
    salesWon: 0,
    salesLost: 0,
    salesInProgress: 0,
    quotationDetailColumn: [
      {
        header: "Expiry Date",
        field: "expiryDate",
        type: "date",
      },
      {
        header: "Sales Order ID",
        field: "salesOrderCode",
        type: "string",
      },
      {
        header: "Sales Agent",
        field: "salesName",
        type: "string",
      },
      {
        header: "Customer RFQ Number",
        field: "customerRfqNo",
        type: "string",
      },
      {
        header: "Exchange Rate To Base Currency",
        field: "exchangeRate",
        type: "currency",
      },
      {
        header: "Version",
        field: "ver",
        type: "string",
      },
      {
        header: "Approval Status",
        field: "approvalStatusDesc",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getQuotations();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getQuotations();
      this.setState({ reload: globalData.reload });
    }
  }

  async getQuotations() {
    const response = await getQuotations();
    const { data, auth } = response.data;
    const { quotations } = data;
    this.setState({ quotations, auth });
    const salesWon = quotations.filter(
      (quotation) => quotation.salesStatus === 3
    );
    const salesLost = quotations.filter(
      (quotation) => quotation.salesStatus === 4
    );
    const salesInProgress = quotations.filter(
      (quotation) => quotation.salesStatus === 1
    );
    this.setState({
      salesWon: salesWon.length,
      salesLost: salesLost.length,
      salesInProgress: salesInProgress.length,
    });
  }

  render() {
    const {
      quotations,
      auth,
      quotationDetailColumn,
      salesWon,
      salesLost,
      salesInProgress,
    } = this.state;
    const actionButtons = [];
    actionButtons.push({
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        this.props.history.push("/menu");
      },
    });
    if (auth.create) {
      actionButtons.push({
        title: "New Quotation",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          this.props.history.push("/sales/quotation/quotation-form");
        },
      });
    }
    return (
      <React.Fragment>
        <PageSubHeader
          title="Quotation List"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/sales/quotation/quotation-list",
              title: "Quotations",
              active: true,
            },
          ]}
          actionButtons={actionButtons}
        />
        <div className="row mb-3">
          <div className="col-sm-4 col-md-4 col-lg-4">
            <Card id="overviewcard" className="border-success">
              <div className="kt-widget4">
                <div className="kt-widget4__item ">
                  <span className="kt-widget4__icon">
                    <i className="fas fa-check-circle kt-font-success" />
                  </span>
                  <div className="kt-widget4__info ">
                    <div className="kt-widget4__highlighttitle">SALES WON</div>
                  </div>
                  <Badge variant="success">{salesWon}</Badge>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <Card id="overviewcard" className="border-warning">
              <div className="kt-widget4">
                <div className="kt-widget4__item ">
                  <span className="kt-widget4__icon">
                    <i className="fas fa-exclamation-circle kt-font-warning" />
                  </span>
                  <div className="kt-widget4__info ">
                    <div className="kt-widget4__highlighttitle">
                      IN PROGRESS
                    </div>
                  </div>
                  <Badge variant="warning">{salesInProgress}</Badge>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <Card id="overviewcard" className="border-danger">
              <div className="kt-widget4">
                <div className="kt-widget4__item ">
                  <span className="kt-widget4__icon">
                    <i className="fas fa-times-circle kt-font-danger" />
                  </span>
                  <div className="kt-widget4__info ">
                    <div className="kt-widget4__highlighttitle">SALES LOST</div>
                  </div>
                  <Badge variant="danger">{salesLost}</Badge>
                </div>
              </div>
            </Card>
          </div>
        </div>
        <ContentLayout>
          {quotations.length ? (
            <CustomDataTable
              data={quotations}
              dataDetailColumns={quotationDetailColumn}
              onRefreshData={() => {
                this.getQuotations();
              }}
              tableName="quotation"
              selectionMode="checkbox"
              columns={[
                {
                  selectionMode: "multiple",
                },
                {
                  header: "Quotation ID",
                  field: "quotationCode",
                  body: (rowData) => {
                    if (rowData.approvalStatus === 1) {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.quotationCode}</span>
                            <BootstrapTooltip title="Document Waiting For Approval">
                              <span className="ml-2">
                                <i className="far fa-clock kt-font-warning"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    } else if (rowData.approvalStatus === 2) {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.quotationCode}</span>
                            <BootstrapTooltip title="Document Approved">
                              <span className="ml-2">
                                <i className="fas fa-check kt-font-success"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    } else if (rowData.approvalStatus === 3) {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.quotationCode}</span>
                            <BootstrapTooltip title="Document Rejected">
                              <span className="ml-2">
                                <i className="fas fa-times kt-font-danger"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.quotationCode}</span>
                            <BootstrapTooltip title="Document No Need Approval">
                              <span className="ml-2">
                                <i className="fas fa-check kt-font-primary"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Type",
                  field: "customerTypeDesc",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.customerTypeDesc}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Name",
                  field: "lead.leadName",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.customerID > 0 ? (
                        <ResponsiveEllipsis
                          text={rowData.customer.customerName}
                          maxLine="1"
                        />
                      ) : (
                        <ResponsiveEllipsis
                          text={rowData.lead.leadName}
                          maxLine="1"
                        />
                      )}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Name",
                  field: "customer.customerName",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.customerID > 0 ? (
                        <ResponsiveEllipsis
                          text={rowData.customer.customerName}
                          maxLine="1"
                        />
                      ) : (
                        <ResponsiveEllipsis
                          text={rowData.lead.leadName}
                          maxLine="1"
                        />
                      )}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Quotation Date",
                  field: "quotationDate",
                  body: (rowData) => formatDate(rowData.quotationDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Quotation Status",
                  field: "salesStatusDesc",
                  body: (rowData) => {
                    if (rowData.salesStatus === 4) {
                      return (
                        <Badge variant="danger">
                          {rowData.salesStatusDesc}
                        </Badge>
                      );
                    } else if (rowData.salesStatus === 1) {
                      return (
                        <Badge variant="warning">
                          {rowData.salesStatusDesc}
                        </Badge>
                      );
                    } else if (rowData.salesStatus === 3) {
                      return (
                        <Badge variant="success">
                          {rowData.salesStatusDesc}
                        </Badge>
                      );
                    } else {
                      return (
                        <Badge variant="dark">{rowData.salesStatusDesc}</Badge>
                      );
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Currency",
                  field: "currency.currencyCode",
                  body: null,
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Grand Total",
                  field: "grandTotal",
                  body: (rowData) => (
                    <NumberFormat
                      value={rowData.grandTotal}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                      renderText={(value) => (
                        <div className="float-right">
                          {rowData.currency.currencyCode} {value}
                        </div>
                      )}
                    />
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.edit &&
                      (rowData.approvalProcessID === 0 ||
                        rowData.approvalProcess.statusID === 2 ||
                        rowData.approvalProcess.statusID === 3) &&
                      rowData.salesStatus !== 3 &&
                      rowData.salesStatus !== 4 ? (
                        <BootstrapTooltip title="Edit Quotation">
                          <button
                            type="button"
                            onClick={() => {
                              this.props.history.push(
                                "/sales/quotation/edit-quotation/" + rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                      {rowData.view ? (
                        <BootstrapTooltip title="Quotation Detail">
                          <button
                            type="button"
                            onClick={() => {
                              this.props.history.push(
                                "/sales/quotation/quotation-detail/" +
                                  rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-list-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                      {rowData.edit &&
                      (rowData.approvalProcessID === 0 ||
                        rowData.approvalProcess.statusID === 2 ||
                        rowData.approvalProcess.statusID === 3) &&
                      rowData.salesStatus !== 3 &&
                      rowData.salesStatus !== 4 ? (
                        <BootstrapTooltip title="Delete Quotation">
                          <button
                            type="button"
                            onClick={(event) =>
                              this.handleDeleteQuotation(rowData.ID)
                            }
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          ) : (
            <Illustration
              imageSource="INVIFO Sales.png"
              description="Hooray! You're ready to have your first Quotation!"
              guidance="Hint: manage your price quotations to potential customers for growing revenue"
              descriptionLeftIcon="fas fa-info-circle kt-font-success"
            ></Illustration>
          )}
        </ContentLayout>
      </React.Fragment>
    );
  }

  handleDeleteQuotation = (quotationID = 0) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Quotation ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelQuotation(quotationID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getQuotations();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };
}

export default withGlobalData(QuotationList);
